import colorPicker from '$Stores/builderStore/modules/colorPicker';
import nightMode from '$Stores/builderStore/modules/nightMode';
import embed from '$Stores/builderStore/modules/embed';

/**
 * Default modules for builder store.
 *
 * @type {Object}
 */
const modules = {
	colorPicker,
	nightMode,
	embed,
};

/**
 * @module modules
 */
export default modules;
